const BATCHES_TABLE_CONFIG = {
  options: {
    tabName: 'batches',
    uri: '/batches'
  },
  columns: [{
    name: '',
    label: '',
    type: 'table-grid-accordion-toggle-cell'
  }, {
    name: 'id',
    label: 'ID',
    type: 'table-grid-text-cell'
  }, {
    name: 'status',
    label: 'STATUS',
    formatFilter: 'uppercase',
    type: 'table-grid-text-cell'
  }, {
    name: 'files',
    label: 'FILES',
    type: 'table-grid-text-cell'
  }, {
    name: 'createdAt',
    label: 'CREATED',
    formatFilter: 'prettifyDateTime',
    type: 'table-grid-text-cell'
  }, {
    name: 'updatedAt',
    label: 'UPDATED',
    formatFilter: 'prettifyDateTime',
    type: 'table-grid-text-cell'
  }, {
    name: 'state',
    label: 'STATE',
    formatFilter: 'uppercaseAllWords',
    type: 'table-grid-text-cell'
  }, {
    name: 'fileSource',
    label: 'FILE SOURCE',
    formatFilter: 'spacify',
    type: 'table-grid-text-cell'
  }, {
    name: '',
    label: '',
    type: 'table-grid-error-report-cell'
  }]
};

module.exports = BATCHES_TABLE_CONFIG;



// WEBPACK FOOTER //
// ./app/models/batchesTableConfig.js